<ng-container *ngIf="isLoading">
  <app-modal-progress></app-modal-progress>
</ng-container>

<div class="modal-header">
  <div class="modal-title h4" *ngIf="moduleName; else fullTitle">
    {{ moduleName }} Delete
  </div>
  <ng-template #fullTitle>
    <div class="modal-title h4">{{ title }}</div>
  </ng-template>
</div>
<div class="modal-body">
  <ng-container *ngIf="isLoading">
    <span *ngIf="moduleName; else fullDeletingText"
      >{{ moduleName }} is deleting...</span
    >
    <ng-template #fullDeletingText>
      <span>{{ deletingText }}</span>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="!isLoading">
    <span *ngIf="moduleName; else fullConfirmationText"
      >Are you sure to permanently delete this
      {{ moduleName | lowercase }}?</span
    >
    <ng-template #fullConfirmationText>
      <span>{{ confirmationText }}</span>
    </ng-template>
  </ng-container>
</div>

<div class="modal-footer">
  <div>
    <button
      type="button"
      class="btn btn-light btn-elevate"
      (click)="onCancelClicked()"
    >
      Cancel</button
    >&nbsp;
    <button
      type="button"
      class="btn btn-primary btn-elevate"
      (click)="onDeleteClicked()"
    >
      Delete
    </button>
  </div>
</div>
